import styles from '../../styles/table.scss';
import Tooltip from '../ui/tooltip';
import { makeid } from '../../constants';

interface Props {
  data: any[][];
  showInvestBtn?: boolean;
  investClick?: any;
}

const TableNew = ({ data = [], showInvestBtn = false }: Props) => (
  <table className="lil-border-separate lil-w-full lil-shadow-sm lil-border-sm lil-rounded-xl lil-border-spacing-0 lil-border-grey-300 lil-mt-5">
    <thead>
      <tr className={styles['bg-light-blue']}>
        {data[0].map((column: any) => (
          <th
            className="lil-text-left lil-text-s-14 lil-text-font-200 lil-font-semibold lil-p-4"
            colSpan={column.span}
            key={makeid()}
          >
            {column.value}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {data.slice(1).map((row: any) => {
        return (
          <tr key={makeid()}>
            {row.map((column, index) => {
              const ID = `${makeid()}-${index}`;
              return (
                <td
                  className="lil-border-b-sm lil-border-grey-250 lil-font-medium lil-p-5"
                  key={makeid()}
                >
                  {column.value}
                  {column.info ? (
                    <Tooltip place={column.place} info={column.info} id={ID} />
                  ) : null}
                  {column.desc ? (
                    <p className={styles.desc}>{column.desc}</p>
                  ) : null}
                </td>
              );
            })}
          </tr>
        );
      })}
      {showInvestBtn ? (
        <tr>
          <td colSpan={2} className="lil-text-center">
            <button
              className="lil-btn lil-btn-link lil-py-4 lil-items-center sm:lil-w-full sm:lil-pl-0"
              onClick={() => {
                window.scrollTo(0, 0);
              }}
            >
              Invest Now{' '}
              <span className="lil-font-medium lil-inline-block">&nbsp; →</span>
            </button>
          </td>
        </tr>
      ) : null}
    </tbody>
  </table>
);

export default TableNew;



// WEBPACK FOOTER //
// ./components/common/tableNew.tsx